<template>
  <div class="container">
    <common-head></common-head>
    <div class="inner">
      <div class="account-page">
        <account-left></account-left>
        <div class="act-page-right">
          <div class="act-c-bd">
            <div class="item">
              <div class="hd-title">借阅记录明细</div>
              <div class="table-con">
                <el-table
                  :data="pageData"
                  stripe
                  style="width: 100%"
                  @row-click="handleRowClick"
                  :default-sort="{ prop: 'date', order: 'descending' }"
                >
                  <el-table-column
                    prop="EBOOKNAME"
                    label="书籍名称"
                    fixed
                  ></el-table-column>
                  <el-table-column
                    prop="BORROWTIME"
                    label="借阅日期"
                    width="180"
                    sortable
                    fixed
                  ></el-table-column>
                  <el-table-column
                    prop="SHOULDTIME"
                    label="归还日期"
                    width="180"
                    sortable
                    fixed
                  ></el-table-column>
                  <el-table-column
                    prop="RETURNEDTIME"
                    label="应归还日期"
                    width="180"
                    sortable
                    fixed
                  ></el-table-column>
                  <!-- <el-table-column prop="BUSINESSTYPETEXT" label="类别" width="180"></el-table-column> -->
                  <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="scope">
                      <el-button v-if="scope.row.STATUS == 0"
                        @click.stop="openProductUrl(scope.row)"
                        type="text"
                        size="small"
                        >归还</el-button>
                        <span style="color: green;" v-if="scope.row.STATUS == 1">已归还</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  layout="prev, pager, next, jumper, total, sizes"
                  class="m-page-list"
                  background
                  @current-change="changePage"
                  :current-page="pageNo"
                  :page-sizes="[10, 20, 30, 40, 50, 100]"
                  :page-size="pageSize"
                  :total="pageTotal"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <common-foot></common-foot>
  </div>
</template>

<script>
import CommonHead from "common/head/Head";
import CommonFoot from "common/foot/Foot";
import AccountLeft from "common/other/AccountLeft";
export default {
  name: "FootPrint",
  components: {
    CommonHead,
    CommonFoot,
    AccountLeft,
  },
  data() {
    return {
      pageData: [],
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      businessType: [],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    handleRowClick(row, column, event){
      var params = {
        Id: row.BOOKID,
        type: 1,
        status: row.SOURCEOPENTYPE
      };
      this.$bti.GetReadBook(params).then((res) => {
        if (!res.data) {
          this.$message({ type: "error", message: "this book deleted!" });
        }else{
          this.$fun.openProductUrl(row.BOOKID, 1)
        }
      });
    },
    changePage(val) {
      this.pageNo = val;
      this.loadData();
    },
    loadData() {
      var params = {
        page: this.pageNo,
        rows: this.pageSize,
        wheres: {},
      };
      this.$bti.BorrowReturnList(params).then((res) => {
        this.pageData = res.data.rows;
        this.pageTotal = res.data.total;
      });
    },
    openProductUrl(row) {
      var params = {
        STATUS: 1,
        BOOKID: row.BOOKID,
        ID: row.ID
      };
      this.$bti.ReadyBook(params).then((res) => {
        if (res.code == 1) {
          this.$message.success("归还成功!");
          this.loadData();
        }
      });
    },
  },
};
</script>

<style lang="css" scoped>
.act-c-bd .hd-title {
  font-size: 16px;
  font-weight: bold;
  height: 35px;
  line-height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/pages/bookjy/BookJy.vue